import store from 'src/js/store';
import actions from '../actions';

const requestFeatureAvailability = (featureName, details = {}) =>
  new Promise((resolve, reject) => {
    store.dispatch(actions.requestFeatureAvailability(featureName, details, resolve, reject));
  });

export default requestFeatureAvailability;
